import { render } from "./manage-product-service.vue?vue&type=template&id=f0c55ca6"
import script from "./manage-product-service.vue?vue&type=script&lang=js"
export * from "./manage-product-service.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__